module.exports = __webpack_public_path__ + "img/success-tick.b2ff333e.png";